// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vIm8J{display:block}.CnyB4{padding:24px 8px;border-bottom:1px solid #e2e2e2;background:#fff}@media screen and (min-width:400px){.CnyB4{padding:24px 16px}}@media screen and (min-width:768px){.CnyB4{padding:16px;border:1px solid #e2e2e2;margin-top:12px;margin-bottom:0;border-radius:8px}}.CnyB4>div{padding:0;margin:0}.vIm8J .psP25{padding:32px 0;background-color:#f4f4f4}@media screen and (min-width:400px){.vIm8J .psP25{padding:32px 8px}}@media screen and (min-width:768px){.vIm8J .psP25{padding:0;background-color:#fcfcfc}.vIm8J .psP25[data-first]{padding-top:40px}}.ouLVk{background-color:#f4f4f4}@media screen and (min-width:768px){.ouLVk{background-color:#fcfcfc}}.XH5js{margin:32px 0}@media screen and (min-width:768px){.XH5js{margin:48px 0}}.u3OhK{margin:16px 0}@media screen and (min-width:768px){.u3OhK{margin-bottom:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "vIm8J",
	"tabs": "CnyB4",
	"grid": "psP25",
	"observerLine": "ouLVk",
	"insertion": "XH5js",
	"loader": "u3OhK"
};
module.exports = ___CSS_LOADER_EXPORT___;
